module.exports = __webpack_public_path__ + "img/voice-lab-xl.3c337943.png";